import Cookies from 'js-cookie';

import { addNewLineToCart, createNewCart, getCart } from '@/shared/service/bc/graphql/cart';

import { LineItems } from './b3Product/b3Product';

export const handleSplitOptionId = (id: string | number) => {
  if (typeof id === 'string' && id.includes('attribute')) {
    const idRight = id.split('[')[1];

    const optionId = idRight.split(']')[0];
    return Number(optionId);
  }

  if (typeof id === 'number') {
    return id;
  }

  return undefined;
};

const isItemDigital = (product: any) => {
  return product.type && typeof product.type === 'string' && product.type.toLowerCase() === 'digital';
};

const cartLineItems = (products: any) => {
  const items = products.map((product: any) => {
    console.log('Processing product:', product);
    const { newSelectOptionList, quantity, optionSelections, allOptions = [] } = product;
    let options = [];
    options = newSelectOptionList || optionSelections;
    const selectedOptions = options.reduce(
      (a: any, c: any) => {
        const optionValue = parseInt(c.optionValue, 10);
        const splitOptionId = handleSplitOptionId(c.optionId);
        const productOption = allOptions.find((option: CustomFieldItems) => {
          const id = option?.product_option_id || option?.id || '';
          return id === splitOptionId;
        });
        if (
          Number.isNaN(optionValue) ||
          productOption?.type === 'text' ||
          productOption?.type === 'Text field'
        ) {
          a.textFields.push({
            optionEntityId: splitOptionId,
            text: c.optionValue,
          });
        } else if (typeof optionValue === 'number') {
          a.multipleChoices.push({
            optionEntityId: splitOptionId,
            optionValueEntityId: parseInt(c.optionValue, 10),
          });
        }

        return a;
      },
      {
        multipleChoices: [],
        textFields: [],
      },
    );

    // Extract product info
    const productId = parseInt(product.productId || product.id, 10);

    // Determine if this is a digital product (case-insensitive check)
    const isDigital = isItemDigital(product);

    // For digital products, handle variants differently
    let variantId;
    if (isDigital) {
      // For digital products with no variants, use 0 as the variantId
      variantId = 0;  // This is crucial - don't use product ID for digital products
      console.log(`Digital product detected: ${productId}, using variantId=${variantId}`);
    } else {
      // For physical products, use normal variant path
      variantId = parseInt(product.variantId || (product.products && product.products.variantId), 10);
    }

    return {
      quantity: parseInt(quantity || product.qty || 1, 10),
      productEntityId: productId,
      ...(isDigital ? {} : { variantEntityId: variantId }),
      selectedOptions,
    };
  });

  return items;
};

export const newDataCart = (productData: any) => ({
  createCartInput: {
    lineItems: cartLineItems(productData),
  },
});

export const deleteCartData = (entityId: any) => ({
  deleteCartInput: {
    cartEntityId: entityId,
  },
});

const getLineItemsData = (cartInfo: any, productData: any) => {
  const lineItems = cartLineItems(productData);

  return {
    addCartLineItemsInput: {
      cartEntityId: cartInfo?.data?.site?.cart?.entityId,
      data: {
        lineItems,
      },
    },
  };
};

export const createNewShoppingCart = async (products: any) => {
  try {
    console.log('createNewShoppingCart', products);

    // Validate products before sending
    const validatedProducts = products.map((product: any) => {
      console.log('Validating product:', product);
      const isDigital = isItemDigital(product);
      console.log(`Product ${product.id || product.productId} (${product.sku || 'no SKU'}): isDigital=${isDigital}`);
      return product;
    });

    const cartData = newDataCart(validatedProducts);
    console.log('cartData', cartData);
    const res = await createNewCart(cartData);
    console.log('createNewShoppingCart response', res);

    if (res?.errors?.length) {
      console.error(
        `Cart error for products:`,
        products.map((p: any) => `${p.id || p.productId} (${p.sku || 'no SKU'})`).join(', '),
      );
      throw new Error(res.errors[0].message);
    }

    if (!res?.data?.cart?.createCart?.cart) {
      throw new Error('Failed to create cart: Empty response');
    }

    const { entityId } = res.data.cart.createCart.cart;
    Cookies.set('cartId', entityId);
    
    return res;
  } catch (error) {
    console.error('Cart creation error:', error);
    throw error;
  }
};

export const updateCart = async (cartInfo: any, productData: any) => {
  console.log('updateCart', cartInfo, productData);
  const newItems = getLineItemsData(cartInfo, productData);
  console.log('newItems', newItems);
  const res = await addNewLineToCart(newItems);
  console.log('updateCart response', res);

  if (res?.errors?.length) {
    throw new Error(res.errors[0].message);
  }

  return res;
};

export const callCart = async (lineItems: LineItems[] | CustomFieldItems[]) => {
  const cartInfo = await getCart();

  console.log('cartInfo', cartInfo, lineItems);

  const res = cartInfo?.data?.site?.cart
    ? await updateCart(cartInfo, lineItems)
    : await createNewShoppingCart(lineItems);

  console.log('callCart response', res);

  return res;
};
